import React from 'react';
import { Accordion } from 'react-bootstrap';


function FAQItem({item, index, onClick}) {
    return (
        <Accordion.Item eventKey={index}>
            <Accordion.Header onClick={onClick}>
                {item.question}
            </Accordion.Header>

            <Accordion.Body>
                {item.answer}
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default FAQItem;